import { faBell } from "@fortawesome/free-regular-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Badge from "../../common/badge/Badge";
import Line from "../../common/line/Line";
import EPostaLogo from "./ePosta-logo.png";
import City from "./City";
import Logo from "./menu/Logo";
import UserInfo from "./menu/UserInfo";
import { GET } from "../../utils/fetchUtil";
import {
  NavigationBar,
  NavigationStart,
  NavigationDropdownMenuItem,
  NavigationLink,
  NavigationEnd,
} from "./navigation";
import BurgerMenu from "./menu/BurgerMenu";
import { InfoBarContext } from "../../common/info";
import { ThemeContext } from "../../common/theme/ThemeContext";
import NotificationPanel from "../../common/notifications/NotificationPanel";
import { useTranslation } from "react-i18next";
import "../header/Header.scss";

function Header({ user }) {
  const location = useLocation();
  const infoBar = useContext(InfoBarContext);
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  const [notificationsCount, setNotificationsCount] = useState(0);

  useEffect(() => {
    GET("/notifications/count", (response) => {
      setNotificationsCount(response.count);
    });
  }, [location]);

  const toggleNotifications = () => {
    infoBar.toggle(`${t("notifications.title")}`, () => <NotificationPanel />);
    setNotificationsCount(0);
  };

  const headerNavigation = {
    width: "100%",
    backgroundColor: "#e0dae4", // bulma: 'has-background-purple-light'
    padding: "0.5rem",
  };
  return (
    <>
      <header className="hero-head">
        <nav className={`navbar has-background-${theme.navColor}`}>
          <Logo img={theme.logo} link={user.applicationConfiguration.externalLinks.homeLink}>
            <BurgerMenu
              backgroundBulmaColor={theme.navLinkColor}
              textBulmaColor={theme.iconColor}
              hoverBulmaColor={theme.iconColor}
            />
          </Logo>
          <City link={user.applicationConfiguration.dashboardUri} name={user.place}>
            <Badge
              className="is-clickable is-pulled-right mt-2 hidden-desktop-scss" //is-hidden-desktop
              iconBulmaColor={theme.navText}
              value={notificationsCount}
              icon={faBell}
              onClick={toggleNotifications}
            />
          </City>
          <NavigationBar id={"navigation"} backgroundBulmaColor={theme.navColor}>
            <NavigationStart
              isHidden={location.pathname === user.applicationConfiguration.dashboardUri}
            >
              <NavigationDropdownMenuItem
                label={t("requests.title").toUpperCase()}
                displayDropdownMenu={
                  location.pathname !== user.applicationConfiguration.dashboardUri
                }
                isHorizontal={true}
                displayLabel={false}
                className={"is-hidden-desktop"}
              >
                <NavigationLink
                  exact={false}
                  isActive={() => location.pathname.includes("/receivedRequests")}
                  to="/receivedRequests"
                  label={t("requests.received.title")}
                />
                <NavigationLink
                  exact={false}
                  isActive={() => location.pathname.includes("/requirementsInResolving")}
                  to="/requirementsInResolving"
                  label={t("requests.inResolving")}
                />
                <NavigationLink
                  exact={false}
                  to="/resolvedRequests"
                  isActive={() => location.pathname.includes("/resolvedRequests")}
                  label={t("requests.resolved")}
                />
                <NavigationLink exact={true} to="/allRequests" label={t("requests.all")} />
                <NavigationLink exact={true} to="/archive" label={t("requests.archive")} />
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/elections"
                  label={t("requests.voting.voting")}
                />
              </NavigationDropdownMenuItem>
            </NavigationStart>
            <NavigationEnd>
              <UserInfo />
            </NavigationEnd>
          </NavigationBar>
        </nav>

        <div className="mb-2 hidden-mobile-scss" style={headerNavigation}>
          <ul className="is-flex headerNavi">
            <li>
              <NavigationLink
                className={"is-size-5-desktop is-size-4-widescreen"}
                exact={false}
                isActive={() => location.pathname.includes("/receivedRequests")}
                to="/receivedRequests"
                label={t("requests.received.title")}
              />
            </li>
            <li>
              <NavigationLink
                className={"is-size-5-desktop is-size-4-widescreen"}
                exact={false}
                isActive={() => location.pathname.includes("/requirementsInResolving")}
                to="/requirementsInResolving"
                label={t("requests.inResolving")}
              />
            </li>
            <li>
              <NavigationLink
                className={"is-size-5-desktop is-size-4-widescreen"}
                exact={false}
                isActive={() => location.pathname.includes("/resolvedRequests")}
                to="/resolvedRequests"
                label={t("requests.resolved")}
              />
            </li>
            <li>
              <NavigationLink
                className={"is-size-5-desktop is-size-4-widescreen"}
                exact={true}
                to="/allRequests"
                label={t("requests.all")}
              />
            </li>
            <li>
              <NavigationLink
                className={"is-size-5-desktop is-size-4-widescreen"}
                exact={true}
                to="/archive"
                label={t("requests.archive")}
              />
            </li>
            <li>
              <NavigationLink
                exact={true}
                to="/elections"
                label={t("requests.voting.voting")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <div className="container is-pulled-right has-text-right mr-4 mt-4 is-clickable hidden-mobile-scss">
              <Badge
                size={2}
                iconBulmaColor={theme.navLinkColor}
                value={notificationsCount}
                icon={faBell}
                iconSize={2}
                onClick={toggleNotifications}
              />
            </div>
          </ul>
        </div>
      </header>
    </>
  );
}

export default Header;
